import ReactGA from 'react-ga';

const GOOGLE_ANALYTICS_ID_MAP = {
	dev: 'UA-199274286-2',
	develop: 'UA-199274286-2',
	production: 'UA-124370350-10'
};

const GOOGLE_ANALYTICS_ID = GOOGLE_ANALYTICS_ID_MAP[process.env.NODE_ENV];

export const initGA = () => {
	if (!window.GA_INITIALIZED) {
		console.log('GA init')
		ReactGA.initialize(GOOGLE_ANALYTICS_ID, { debug: true });
		window.GA_INITIALIZED = true
	};
}

export const sendPageView = pathname => {
	console.log(`Logging pageview for ${pathname}`);
	ReactGA.set({ page: pathname });
	ReactGA.pageview(pathname);
}



// WEBPACK FOOTER //
// ./src/util/analytics.js